import { monday } from '../../platformSpecific/monday';

const getItemsByIds = async (itemIds) => {
  const hasItems = itemIds.length > 0;

  if (!hasItems) {
    return [];
  }
  const response = await monday.api(
    `query {
        items (ids: [${itemIds.join(', ')}]) {
          id
          name
        }
    }`
  );
  return response.data.items;
};

const createItem = async (boardId, name) => {
  const response = await monday.api(
    `mutation {
        create_item (board_id: ${boardId}, item_name: "${name}") {
          id
          name
        }
    }`
  );
  return response.data.create_item;
};

const openItemDialog = async (itemId) =>
  monday.execute('openItemCard', { itemId });

const getItemTypes = async () => [];

export { getItemsByIds, createItem, openItemDialog, getItemTypes };
